import { render, staticRenderFns } from "./problembuilder.vue?vue&type=template&id=6ad3c67a&"
import script from "./problembuilder.vue?vue&type=script&lang=ts&"
export * from "./problembuilder.vue?vue&type=script&lang=ts&"
import style0 from "./problembuilder.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports